import styled from 'styled-components';

export const ConsultantsColumn = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	gap: 10px;
`;

export const BarBody = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	gap: 8px;
`;

export const FiltersRow = styled.div`
	display: flex;
	align-items: center;
	gap: 30px;
`;

export const ActionsRow = styled.div`
	display: flex;
	justify-content: flex-end;
	gap: 12px;
`;

export const Wrapper = styled.div`
	overflow: scroll;
	height: calc(100vh - 80px);
	display: flex;
	flex-direction: column;
	align-items: center;
	gap: 20px;
`;
